import { mergeWith } from 'lodash';

function createBrandConfigGenerator(brandConfig) {
    return (...overrides) => mergeWith({}, brandConfig, ...overrides, (objValue, srcValue) => {
        if (Array.isArray(objValue)) {
            return srcValue; // replace arrays, don't concat them
        }
    });
}

export default createBrandConfigGenerator;
